@if (!isGeneratingReport) {
  <div (click)="share()">
    @if (isAndroid) {
      <ion-icon name="share-social-outline" />
    } @else {
      <ion-icon name="share-outline" />
    }
  </div>
} @else {
  <ion-spinner id="spinner"
              name="crescent" />
}